import { render, staticRenderFns } from "./cSkillAdmin.vue?vue&type=template&id=6a74d9b0&scoped=true"
import script from "./cSkillAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./cSkillAdmin.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a74d9b0",
  null
  
)

export default component.exports